import { Glyphicon } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { IntegrationDescriptionModalWrapper } from '../IntegrationDescriptionModal.styles';
import {
  FeatureList,
  IncludedTitle,
} from './HostfullyAccountingDescriptionBody.styles';

const HostfullyAccountingDescriptionBody = () => {
  const { t } = useTranslation();

  // Features list is stored as an array in the translation files
  const featuresValue: unknown = t(
    'pageIntegrations.integrationsDescriptions.hostfullyaccounting.features',
    { returnObjects: true },
  );

  const features = Array.isArray(featuresValue)
    ? featuresValue.filter(
        (feature): feature is string => typeof feature === 'string',
      )
    : [];

  return (
    <IntegrationDescriptionModalWrapper>
      <p>
        {t(
          'pageIntegrations.integrationsDescriptions.hostfullyaccounting.intro',
        )}
      </p>

      <IncludedTitle>
        {t(
          'pageIntegrations.integrationsDescriptions.hostfullyaccounting.includedTitle',
        )}
      </IncludedTitle>

      <FeatureList>
        {features.map((feature) => (
          <li key={feature} data-testid="ha-description-feature">
            <Glyphicon glyph="ok" aria-hidden="true" />
            {feature}
          </li>
        ))}
      </FeatureList>

      <p>
        {t(
          'pageIntegrations.integrationsDescriptions.hostfullyaccounting.availability',
        )}
      </p>
    </IntegrationDescriptionModalWrapper>
  );
};

export default HostfullyAccountingDescriptionBody;
